import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button } from '@cian/ui-kit';

import logo from './assets/logo.svg';
import { BanksList } from './components/BanksList';
import * as styles from './Mortgage.css';
import { Section } from '../Section';

interface IMortgageProps {
  banksLogo: string[];
  banksMoreCount: number;
  buttonText: string;
  description: string;
  url: string;
  onBannerClick: () => void;
  onBannerShow: () => void;
}

export const Mortgage: React.FC<IMortgageProps> = ({
  banksMoreCount,
  banksLogo,
  buttonText,
  description,
  onBannerClick,
  onBannerShow,
  url,
}) => {
  return (
    <Section>
      <ActionAfterViewObserver triggerOnce callback={onBannerShow} wrapper={false}>
        <a className={styles['container']} href={url} target="_blank" rel="noopener noreferrer" onClick={onBannerClick}>
          <div className={styles['inner']}>
            <div className={styles['description']}>
              <img className={styles['mortgage-logo']} src={logo} alt="ЦИАН.Ипотека" />
              <h3 className={styles['description-text']}>{description}</h3>
              <div className={styles['button']}>
                <Button size="M">{buttonText}</Button>
              </div>
            </div>
            <div className={styles['banks-list']}>
              <BanksList logos={banksLogo} moreCount={banksMoreCount} />
            </div>
          </div>
        </a>
      </ActionAfterViewObserver>
    </Section>
  );
};
